/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Stato di un periodo di rendicontazione esercenti
 */
export enum PeriodoRendicontazioneStatus {

    IN_ATTESA = 'IN_ATTESA',

    ABILITATO = 'ABILITATO',

    DISABILITATO = 'DISABILITATO'
}

